<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Invoice Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submitForm(1)"
                  ref="purchaseInvoiceForm"
                  id="purchaseInvoiceForm"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-select
                        label="Receive Type"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="receive_type.value.value"
                        :items="receiveTypes"
                        :item-title="(item) => `${item.label}`"
                        item-value="value"
                        :error-messages="receive_type.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :disabled="isEditMode"
                        @update:model-value="onReceiveTypeChange"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Receive Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-select>

                      <v-autocomplete
                        v-if="receive_type.value.value === 'PO_RECEIVE'"
                        label="PO Receive"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="po_receive_master_id.value.value"
                        :items="filteredPoReceiveList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        :error-messages="po_receive_master_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :disabled="isEditMode"
                        @update:model-value="onPoReceiveChange"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          PO Receive
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                        v-if="receive_type.value.value === 'ASSET_ACQUISITION'"
                        label="Asset Acquisition Receive"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="asset_acquisition_master_id.value.value"
                        :items="filteredAssetAcquisitionList"
                        :item-title="(item) => `${item.code}`"
                        item-value="id"
                        :error-messages="asset_acquisition_master_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :disabled="isEditMode"
                        @update:model-value="onAssetAcquisitionChange"
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        <template #label>
                          Asset Acquisition Receive
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Invoice Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="invoice_date.value.value"
                        :error-messages="invoice_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-text-field
                        label="Supplier"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        :model-value="supplierName"
                        readonly
                      ></v-text-field>

                      <v-text-field
                        label="Warehouse"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        :model-value="warehouseName"
                        readonly
                      ></v-text-field>

                      
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="purpose_id.value.value"
                        :items="getPurposeList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="purpose_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                      
                        <template #label>
                          Purpose/Project
                          <span class="text-red-accent-4"></span>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        label="Supplier Invoice No."
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="supplier_invoice_no.value.value"
                        :error-messages="supplier_invoice_no.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-text-field>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Purchase Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purchase_date.value.value"
                        :disabled="true"
                        autocomplete="off"
                      ></v-date-input>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Receive Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="receive_date.value.value"
                        :disabled="true"
                        autocomplete="off"
                      ></v-date-input>

                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Shipping Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="shipping_date.value.value"
                        :disabled="true"
                        autocomplete="off"
                      ></v-date-input>

                      <v-textarea
                        label="Remarks"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="remarks.value.value"
                        autocomplete="off"
                        rows="2"
                        clearable
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Invoice Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="pt-0">
                  <v-col cols="12">
                    <v-table
                      density="compact"
                      :loading="loading"
                      fixed-header
                      class="table-dotted-border-bottom"
                    >
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">SL</th>
                          <th class="text-center" style="width: 10%">Code</th>
                          <th class="text-left" style="width: 25%">Product</th>
                          <th class="text-center" style="width: 10%"> Quantity </th>
                          <th v-if="isFreeItem" class="text-center" style="width: 10%">Free Quantity </th>
                          <th class="text-center" style="width: 15%">Unit</th>
                          <th class="text-center" style="width: 15%">Rate</th>
                          <th class="text-center" style="width: 15%">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in cart"
                          v-if="cart.length > 0"
                          :key="`${item.product_id}-${index}`"
                        >
                          <td class="text-center py-1">{{ index + 1 }}</td>
                          <td class="text-center py-1">
                            {{ item.product_code }}
                          </td>
                          <td class="text-left py-1" style="white-space: normal">
                            {{ item.product_name }}
                          </td>
                          <td class="text-center py-2">
                            <v-text-field
                              type="number"
                              min="0"
                              density="compact"
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              v-model.number="item.qty"
                              hide-details
                              style="width: 80px"
                              @update:model-value="
                                item.total = Number(item.qty) * Number(item.rate)
                              "
                              @blur="
                                item.total = Number(item.qty) * Number(item.rate)
                              "
                            ></v-text-field>
                          </td>

                          <td class="text-center py-1">
                            {{ item.unit_name }}
                          </td>
                          <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                style="width:100px;"
                                label=""
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                type="number"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.rate"
                                hide-details
                                :error="item.rate < 1"
                                :error-messages=" item.qty < 1 ? 'rate must be greater than 0' : '' "
                                @update:model-value=" item.total = item.qty * item.rate "
                              ></v-text-field>
                          </td>
                          <td class="text-right py-1">
                            {{ $numberFormat(item.total) }}
                          </td>
                        </tr>

                        <tr v-else>
                          <td colspan="7" class="text-center text-red">
                            No items found. Please select a PO Receive.
                          </td>
                        </tr>
                      </tbody>
                      <tfoot v-if="cart.length > 0">
                        <tr>
                          <td colspan="5" class="text-right py-1">
                            Sub Total
                          </td>
                          <td colspan="2" class="text-right py-1">
                            {{ $numberFormat(subTotal) }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right py-1">
                            {{ discountLabel }}
                          </td>
                          <td colspan="2" class="text-right py-1">
                            <v-text-field
                              v-model="discount_input.value.value"
                              density="compact"
                              label="%"
                              hide-details
                              dense
                              autocomplete="off"
                              variant="outlined"
                              readonly
                            />
                          </td>
                          <td colspan="2" class="text-right py-1">
                            {{ $numberFormat(discountAmount) }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right py-1">
                            {{ taxLabel }}
                          </td>
                          <td colspan="2" class="text-right py-1">
                            <v-text-field
                              v-model="tax_input.value.value"
                              density="compact"
                              label="%"
                              hide-details
                              dense
                              autocomplete="off"
                              variant="outlined"
                              readonly
                            />
                          </td>
                          <td colspan="2" class="text-right py-1">
                            {{ $numberFormat(taxAmount) }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right py-1">
                            {{ vatLabel }}
                          </td>
                          <td colspan="2" class="text-right py-1">
                            <v-text-field
                              v-model="vat_input.value.value"
                              density="compact"
                              label="%"
                              hide-details
                              dense
                              autocomplete="off"
                              variant="outlined"
                              readonly
                            />
                          </td>
                          <td colspan="2" class="text-right py-1">
                            {{ $numberFormat(vatAmount) }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="5" class="text-right py-1">
                            Grand Total
                          </td>
                          <td colspan="2" class="text-right py-1">
                            {{ $numberFormat(grandTotal) }}
                          </td>
                        </tr>
                      </tfoot>
                    </v-table>
                  </v-col>
                </v-row>

                <v-divider class="my-4"></v-divider>
                <v-card-actions>
                  <v-row class="pt-2 justify-end">
                    <v-btn
                      class="bg-grey-darken-1 me-2"
                      variant="flat"
                      @click="submitForm(0)"
                      :disabled="cart.length === 0"
                    >
                      DRAFT
                    </v-btn>
                    <v-btn
                      class="bg-primary"
                      variant="flat"
                      @click="submitForm(1)"
                      :disabled="cart.length === 0"
                    >
                      POST
                    </v-btn>
                  </v-row>
                </v-card-actions>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getCurrentInstance } from "vue";
import { toast } from "vue3-toastify";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import formattedDate from "@/plugins/dateFormatter";
import { getCompanyInfo } from '@/plugins/helpers'

export default {
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    supplierName: "",
    warehouseName: "",
    purpose_id: null,
    isFreeItem:false,
    cart: [],
    receiveTypes: [
      { label: "PO Receive", value: "PO_RECEIVE" },
      { label: "Asset Acquisition Receive", value: "ASSET_ACQUISITION" }
    ],
    discountAmountPrefill: null,
    taxAmountPrefill: null,
    vatAmountPrefill: null,
    isEditMode: false,
    // Meta info for discount, tax, vat:
    // per        -> percentage value (e.g. 10 or "10%")
    // amount     -> flat amount (e.g. 10)
    // type       -> include/exclude flag for tax/vat (1 = include, 2 = exclude)
    // value_type -> 1 = percent, 2 = flat (where available)
    discountMeta: {
      per: "",
      amount: "",
      type: "",
      value_type: "",
    },
    taxMeta: {
      per: "",
      amount: "",
      type: "",
      value_type: "",
    },
    vatMeta: {
      per: "",
      amount: "",
      type: "",
      value_type: "",
    },
  }),
  created() {
    // if (this.$store.getters.getInvPoReceiveList.length === 0) {
      this.loadPoReceiveList();
    // }
    // if (this.$store.getters.getAssetAcquisitionList.length === 0) {
      this.loadAssetAcquisitionList();
    // }
    // if (this.$store.getters.getPurposeList.length === 0) {
      this.$store.dispatch("getPurposeList");
    // }
  },
  computed: {
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    filteredPoReceiveList() {
      const receives = this.$store.getters.getInvPoReceiveList || [];
      return receives.filter((item) =>
        item.branch_id ? item.branch_id === this.branchId : true
      );
    },
    getPurposeList(){
      return this.$store.getters.getPurposeList;
    },
    filteredAssetAcquisitionList() {
      const acquisitions = this.$store.getters.getAssetAcquisitionList || [];
      return acquisitions.filter((item) =>
        item.branch_id ? item.branch_id === this.branchId : true
      );
    },
    subTotal() {
      return this.cart.reduce((sum, item) => sum + Number(item.total || 0), 0);
    },
    discountAmount() {
      const rawValue = this.discount_input?.value?.value;
      if (!rawValue) {
        if (
          this.discountAmountPrefill !== null &&
          this.discountAmountPrefill !== undefined
        ) {
          const parsed = Number(this.discountAmountPrefill);
          if (!Number.isNaN(parsed)) {
            return parsed;
          }
        }
        return 0;
      }
      const val = rawValue.toString().trim();
      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subTotal * percentage) / 100 || 0;
      }
      return parseFloat(val) || 0;
    },
    subtotalAfterDiscount() {
      return this.subTotal - this.discountAmount;
    },
    taxAmount() {
      const rawValue = this.tax_input?.value?.value;
      if (!rawValue) {
        if (this.taxAmountPrefill !== null && this.taxAmountPrefill !== undefined) {
          const parsed = Number(this.taxAmountPrefill);
          if (!Number.isNaN(parsed)) {
            return parsed;
          }
        }
        return 0;
      }
      const val = rawValue.toString().trim();
      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subtotalAfterDiscount * percentage) / 100 || 0;
      }
      return parseFloat(val) || 0;
    },
    vatAmount() {
      const rawValue = this.vat_input?.value?.value;
      if (!rawValue) {
        if (this.vatAmountPrefill !== null && this.vatAmountPrefill !== undefined) {
          const parsed = Number(this.vatAmountPrefill);
          if (!Number.isNaN(parsed)) {
            return parsed;
          }
        }
        return 0;
      }
      const val = rawValue.toString().trim();
      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subtotalAfterDiscount * percentage) / 100 || 0;
      }
      return parseFloat(val) || 0;
    },
    grandTotal() {
      return this.subTotal - this.discountAmount + this.taxAmount + this.vatAmount;
    },
    discountLabel() {
      const normalize = (val) =>
        val === undefined || val === null ? "" : String(val).trim();
      const per = normalize(this.discountMeta.per);
      const amount = normalize(this.discountMeta.amount);
      if (per) {
        return `Discount (${per})`;
      }
      if (amount) {
        return `Discount (${amount})`;
      }
      return "Discount";
    },
    taxLabel() {
      const normalize = (val) =>
        val === undefined || val === null ? "" : String(val).trim();
      const per = normalize(this.taxMeta.per);
      const amount = normalize(this.taxMeta.amount);
      const typeRaw = normalize(this.taxMeta.type);
      const valueTypeRaw = normalize(this.taxMeta.value_type);
      const valueType = valueTypeRaw ? Number(valueTypeRaw) : null; // 1 = percent, 2 = flat

      // Choose base display value based on value_type if available
      let baseDisplay = "";
      if (valueType === 1) {
        // percent
        if (per) {
          baseDisplay = per.endsWith("%") ? per : `${per}%`;
        }
      } else if (valueType === 2) {
        // flat
        baseDisplay = amount || per;
      }

      // Fallback logic when value_type is not present
      if (!baseDisplay) {
        if (per) {
          baseDisplay = per.endsWith("%") ? per : `${per}%`;
        } else if (amount) {
          baseDisplay = amount;
        }
      }

      if (!baseDisplay) {
        return "Tax";
      }

      if (typeRaw) {
        const typeValue = Number(typeRaw);
        const typeLabel =
          !Number.isNaN(typeValue) && typeValue === 1 ? "Included" : "Excluded";
        return `Tax (${baseDisplay} ${typeLabel})`;
      }
      return `Tax (${baseDisplay})`;
    },
    vatLabel() {
      const normalize = (val) =>
        val === undefined || val === null ? "" : String(val).trim();
      const per = normalize(this.vatMeta.per);
      const amount = normalize(this.vatMeta.amount);
      const typeRaw = normalize(this.vatMeta.type);
      const valueTypeRaw = normalize(this.vatMeta.value_type);
      const valueType = valueTypeRaw ? Number(valueTypeRaw) : null; // 1 = percent, 2 = flat

      // Choose base display value based on value_type if available
      let baseDisplay = "";
      if (valueType === 1) {
        // percent
        if (per) {
          baseDisplay = per.endsWith("%") ? per : `${per}%`;
        }
      } else if (valueType === 2) {
        // flat
        baseDisplay = amount || per;
      }

      // Fallback logic when value_type is not present
      if (!baseDisplay) {
        if (per) {
          baseDisplay = per.endsWith("%") ? per : `${per}%`;
        } else if (amount) {
          baseDisplay = amount;
        }
      }

      if (!baseDisplay) {
        return "Vat";
      }

      if (typeRaw) {
        const typeValue = Number(typeRaw);
        const typeLabel =
          !Number.isNaN(typeValue) && typeValue === 1 ? "Included" : "Excluded";
        return `Vat (${baseDisplay} ${typeLabel})`;
      }
      return `Vat (${baseDisplay})`;
    },
  },
  methods: {
    loadPoReceiveList() {
      const today = new Date();
      const payload = {
        from_date: formattedDate(today),
        to_date: formattedDate(today),
      };
      this.$store
        .dispatch("getInvPoReceiveList", payload)
        .catch((error) => {
          console.error("Failed to load PO Receive list:", error);
          toast.error(
            error?.response?.data?.message || "Failed to load PO Receive list"
          );
        });
    },
    loadAssetAcquisitionList() {
      this.$store
        .dispatch("getAssetAcquisitionList", {})
        .catch((error) => {
          //console.error("Failed to load Asset Acquisition list:", error);
          /* toast.error(
            error?.response?.data?.message || "Failed to load Asset Acquisition list"
          ); */
        });
    },
    onReceiveTypeChange() {
      // Reset both receive IDs when type changes
      this.po_receive_master_id.value.value = null;
      this.asset_acquisition_master_id.value.value = null;
      this.resetInvoiceForm(false);
    },
    async onAssetAcquisitionChange(selectedId) {
      if (!selectedId) {
        this.resetInvoiceForm(true);
        return;
      }
      try {
        this.loading = true;
        this.$store.commit("SET_LOADING", { color: "primary" });
        const response = await this.$store.dispatch(
          "getAssetAcquisitionById",
          selectedId
        );
        const data = response.data || response;
        
        // Load purchase order data only for basic info (supplier, dates, etc.)
        // Not needed for discount/tax/vat as Asset Acquisition doesn't use those
        const purchaseOrderId = data.pur_order_master_id || data.purchaseOrder?.id;
        if (purchaseOrderId) {
          try {
            const poResponse = await this.$store.dispatch("getPurOrderById", purchaseOrderId);
            const poData = poResponse.data || poResponse;
            // Merge purchase order data for supplier and other basic info only
            data.purchaseOrder = { ...data.purchaseOrder, ...poData };
          } catch (poError) {
            console.warn("Failed to load purchase order details:", poError);
            // Continue even if PO loading fails
          }
        }
        
        this.populateFromAssetAcquisition(data);
      } catch (error) {
        console.error("Failed to load Asset Acquisition data:", error);
        toast.error(
          error?.response?.data?.message || "Failed to load Asset Acquisition data"
        );
      } finally {
        this.loading = false;
        this.$store.commit("UNSET_LOADING");
      }
    },
    populateFromAssetAcquisition(data) {
      const purchaseOrder = data.purchaseOrder || {};

      this.purchase_invoice_master_id.value.value = null;
      this.asset_acquisition_master_id.value.value = data.id;
      this.pur_order_master_id.value.value =
        data.pur_order_master_id || purchaseOrder.id || null;

      this.purchase_date.value.value = data.asset_acquisition_date
        ? new Date(data.asset_acquisition_date)
        : null;
      this.receive_date.value.value = data.asset_acquisition_date
        ? new Date(data.asset_acquisition_date)
        : null;
      this.shipping_date.value.value = null;

      // Asset acquisition typically doesn't have warehouse, but check if available
      this.warehouse_id.value.value = null;
      this.warehouseName = "";
      this.purpose_id.value.value = null;

      this.supplier_id.value.value =
        data.purchaseOrder?.supplier_id || purchaseOrder?.supplier_id || null;
      this.supplierName =
        data.purchaseOrder?.supplier?.supplier_name ||
        purchaseOrder?.supplier?.supplier_name ||
        "";

      this.remarks.value.value = data.remarks || "";

      // Set purchase type if available from purchase order
      const rawPurchaseType = purchaseOrder.purchase_type ?? null;
      this.purchase_type.value.value =
        rawPurchaseType !== null && rawPurchaseType !== undefined
          ? Number.isNaN(Number(rawPurchaseType))
            ? rawPurchaseType
            : Number(rawPurchaseType)
          : null;

      // Set requisition master id if available from purchase order
      this.requisition_master_id.value.value =
        purchaseOrder.requisition_master_id ?? null;

      // Reset discount/tax/vat fields - Asset Acquisition Receive doesn't populate these
      this.discountAmountPrefill = null;
      this.discountMeta = { per: "", amount: "", type: "", value_type: "" };
      this.discount_input.value.value = "";

      this.taxAmountPrefill = null;
      this.taxMeta = { per: "", amount: "", type: "", value_type: "" };
      this.tax_input.value.value = "";

      this.vatAmountPrefill = null;
      this.vatMeta = { per: "", amount: "", type: "", value_type: "" };
      this.vat_input.value.value = "";

      // Populate cart from asset acquisition details
      this.cart = [];
      const details = data.details || [];
      details.forEach((item) => {
        this.cart.push({
          product_id: item.product_id,
          product_name: item.product?.name || "",
          product_code: item.product?.code || "",
          qty: Number(item.quantity || 0),
          free_qty: Number(item.free_qty || 0),
          unit_name: item.product?.unit?.name || "",
          rate: Number(item.purchase_cost || 0),
          total: Number(item.quantity || 0) * Number(item.purchase_cost || 0),
        });
      });
    },
    async onPoReceiveChange(selectedId) {
      if (!selectedId) {
        this.resetInvoiceForm(true);
        return;
      }
      try {
        this.loading = true;
        this.$store.commit("SET_LOADING", { color: "primary" });
        const data = await this.$store.dispatch(
          "getInvPoReceiveById",
          selectedId
        );
        this.populateFromReceive(data);
      } catch (error) {
        console.error("Failed to load PO Receive data:", error);
        toast.error(
          error?.response?.data?.message || "Failed to load PO Receive data"
        );
      } finally {
        this.loading = false;
        this.$store.commit("UNSET_LOADING");
      }
    },
    populateFromReceive(data) {
      const purchaseOrder = data.purordermaster || {};

      this.purchase_invoice_master_id.value.value = null;
      this.po_receive_master_id.value.value = data.id;
      this.pur_order_master_id.value.value =
        data.pur_order_master_id || purchaseOrder.id || null;

      this.purchase_date.value.value = data.purchase_date
        ? new Date(data.purchase_date)
        : null;
      this.receive_date.value.value = data.receive_date
        ? new Date(data.receive_date)
        : null;
      this.shipping_date.value.value = data.shipping_date
        ? new Date(data.shipping_date)
        : null;
      const rawPurchaseType =
        purchaseOrder.purchase_type ?? data.purchase_type ?? null;
      this.purchase_type.value.value =
        rawPurchaseType !== null && rawPurchaseType !== undefined
          ? Number.isNaN(Number(rawPurchaseType))
            ? rawPurchaseType
            : Number(rawPurchaseType)
          : null;
      this.requisition_master_id.value.value =
        purchaseOrder.requisition_master_id ??
        data.requisition_master_id ??
        null;

      this.warehouse_id.value.value =
        data.warehouse_id || data.warehouse?.id || null;
      this.warehouseName = data.warehouse?.name || "";
      this.purpose_id.value.value = data.purpose_id;

      this.supplier_id.value.value =
        data.supplier_id || data.supplier?.id || null;
      this.supplierName =
        data.supplier?.supplier_name ||
        data.supplier_name ||
        data.supplier?.name ||
        "";

      this.remarks.value.value = data.remarks || "";

      // First set meta objects from Purchase Order / Receive data
      this.discountAmountPrefill =
        purchaseOrder.discount_amount ?? data.discount_amount ?? null;
      this.discountMeta = {
        per: purchaseOrder.discount_per ?? data.discount_per ?? "",
        amount: purchaseOrder.discount_amount ?? data.discount_amount ?? "",
        // discount_type here is actually the value type (1 = percent, 2 = flat)
        type: purchaseOrder.discount_type ?? data.discount_type ?? "",
        value_type: purchaseOrder.discount_type ?? data.discount_type ?? "",
      };

      this.taxAmountPrefill =
        purchaseOrder.tax_amount ?? data.tax_amount ?? null;
      this.taxMeta = {
        per: purchaseOrder.tax_per ?? data.tax_per ?? "",
        amount: purchaseOrder.tax_amount ?? data.tax_amount ?? "",
        // type is include/exclude; value_type is 1 = percent, 2 = flat
        type: purchaseOrder.tax_type ?? data.tax_type ?? "",
        value_type: purchaseOrder.tax_value_type ?? data.tax_value_type ?? "",
      };

      this.vatAmountPrefill =
        purchaseOrder.vat_amount ?? data.vat_amount ?? null;
      this.vatMeta = {
        per: purchaseOrder.vat_per ?? data.vat_per ?? "",
        amount: purchaseOrder.vat_amount ?? data.vat_amount ?? "",
        // type is include/exclude; value_type is 1 = percent, 2 = flat
        type: purchaseOrder.vat_type ?? data.vat_type ?? "",
        value_type: purchaseOrder.vat_value_type ?? data.vat_value_type ?? "",
      };

      // Now build discount input based on value_type (1 = percent, 2 = flat)
      const discountValueType = this.discountMeta.value_type
        ? Number(this.discountMeta.value_type)
        : null;
      if (discountValueType === 1 && this.discountMeta.per !== "") {
        const rawPer = String(this.discountMeta.per).trim();
        this.discount_input.value.value = rawPer.endsWith("%")
          ? rawPer
          : `${rawPer}%`;
      } else if (discountValueType === 2 && this.discountMeta.amount !== "") {
        this.discount_input.value.value = String(this.discountMeta.amount);
      } else {
        this.discount_input.value.value = this.formatChargeValue(
          this.discountMeta.per,
          this.discountMeta.amount,
          this.discountMeta.type
        );
      }

      // Build tax input based on value_type (1 = percent, 2 = flat)
      const taxValueType = this.taxMeta.value_type
        ? Number(this.taxMeta.value_type)
        : null;
      if (taxValueType === 1 && this.taxMeta.per !== "") {
        const rawPer = String(this.taxMeta.per).trim();
        this.tax_input.value.value = rawPer.endsWith("%")
          ? rawPer
          : `${rawPer}%`;
      } else if (taxValueType === 2 && this.taxMeta.amount !== "") {
        this.tax_input.value.value = String(this.taxMeta.amount);
      } else {
        this.tax_input.value.value = this.formatChargeValue(
          this.taxMeta.per,
          this.taxMeta.amount,
          this.taxMeta.type
        );
      }

      // Build vat input based on value_type (1 = percent, 2 = flat)
      const vatValueType = this.vatMeta.value_type
        ? Number(this.vatMeta.value_type)
        : null;
      if (vatValueType === 1 && this.vatMeta.per !== "") {
        const rawPer = String(this.vatMeta.per).trim();
        this.vat_input.value.value = rawPer.endsWith("%")
          ? rawPer
          : `${rawPer}%`;
      } else if (vatValueType === 2 && this.vatMeta.amount !== "") {
        this.vat_input.value.value = String(this.vatMeta.amount);
      } else {
        this.vat_input.value.value = this.formatChargeValue(
          this.vatMeta.per,
          this.vatMeta.amount,
          this.vatMeta.type
        );
      }

      this.cart = [];
      const details =
        data.InvPoReceiveDetails || data.inv_po_receive_details || [];
      details.forEach((item) => {
        this.cart.push({
          product_id: item.product_id,
          product_name: item.product?.name || "",
          product_code: item.product?.code || "",
          qty: Number(item.qty || 0),
          free_qty: Number(item.free_qty || 0),
          unit_name: item.product?.unit?.name || "",
          rate: Number(item.rate || 0),
          total: Number(item.qty || 0) * Number(item.rate || 0),
        });
      });
    },
    resetInvoiceForm(clearReceiveSelection = false) {
      if (clearReceiveSelection) {
        this.receive_type.value.value = null;
        this.po_receive_master_id.value.value = null;
        this.asset_acquisition_master_id.value.value = null;
      }
      this.purchase_invoice_master_id.value.value = null;
      this.pur_order_master_id.value.value = null;
      this.purchase_date.value.value = null;
      this.receive_date.value.value = null;
      this.shipping_date.value.value = null;
      this.warehouse_id.value.value = null;
      this.supplier_id.value.value = null;
      this.remarks.value.value = "";
      this.discount_input.value.value = "";
      this.tax_input.value.value = "";
      this.vat_input.value.value = "";
      this.purchase_type.value.value = null;
      this.requisition_master_id.value.value = null;
      this.discountAmountPrefill = null;
      this.taxAmountPrefill = null;
      this.vatAmountPrefill = null;
      this.discountMeta = { per: "", amount: "", type: "", value_type: "" };
      this.taxMeta = { per: "", amount: "", type: "", value_type: "" };
      this.vatMeta = { per: "", amount: "", type: "", value_type: "" };
      this.supplierName = "";
      this.warehouseName = "";
      this.purpose_id.value.value = null;
      this.cart = [];
    },
    formatChargeValue(percentage, amount, type) {
      const normalize = (val) =>
        val === undefined || val === null ? "" : String(val).trim();

      const rawPercentage = normalize(percentage);
      const rawAmount = normalize(amount);
      const typeDefined =
        type !== undefined && type !== null && String(type).trim() !== "";

      let isPercentage = false;
      if (typeDefined) {
        isPercentage = Number(String(type).trim()) === 1;
      } else if (rawAmount !== "" && rawPercentage !== "") {
        // If both exist and type is null, prefer amount (flat) over percentage
        // This handles legacy data where discount_type was null
        isPercentage = false;
      } else if (rawPercentage !== "") {
        isPercentage = true;
      }

      if (!isPercentage && rawAmount === "" && rawPercentage !== "") {
        isPercentage = true;
      }

      if (isPercentage && rawPercentage !== "") {
        if (rawPercentage.endsWith("%")) {
          return rawPercentage;
        }
        const parsedPercentage = parseFloat(rawPercentage);
        return Number.isNaN(parsedPercentage)
          ? rawPercentage
          : `${parsedPercentage}%`;
      }

      if (rawAmount !== "") {
        return rawAmount;
      }

      return "";
    },
    normalizePercentageValue(value) {
      if (value === undefined || value === null) {
        return null;
      }
      const cleaned = String(value).trim().replace("%", "");
      if (cleaned === "") {
        return null;
      }
      const parsed = Number(cleaned);
      return Number.isNaN(parsed) ? null : parsed;
    },
    normalizeTypeValue(typeValue) {
      if (typeValue === undefined || typeValue === null) {
        return null;
      }
      const cleaned = String(typeValue).trim();
      if (cleaned === "") {
        return null;
      }
      const parsed = Number(cleaned);
      return Number.isNaN(parsed) ? cleaned : parsed;
    },
    async populateFromInvoice(invoiceData) {
      try {
        this.isEditMode = true;
        
        // Set invoice master id
        this.purchase_invoice_master_id.value.value = invoiceData.id;
        
        // Set invoice date
        this.invoice_date.value.value = invoiceData.invoice_date
          ? new Date(invoiceData.invoice_date)
          : new Date();
        
        // Set status
        this.status.value.value = invoiceData.status ?? 1;
        
        // Set remarks
        this.remarks.value.value = invoiceData.remarks || "";
        this.supplier_invoice_no.value.value = invoiceData.supplier_invoice_no || "";
        
        // Set discount, tax, vat
      this.discountMeta = {
        per: invoiceData.discount_per ?? "",
        amount: invoiceData.discount_amount ?? "",
        type: invoiceData.discount_type ?? "",
        value_type: invoiceData.discount_type ?? "",
      };
        this.discount_input.value.value = this.formatChargeValue(
          invoiceData.discount_per,
          invoiceData.discount_amount,
          invoiceData.discount_type
        );
        this.discountAmountPrefill = invoiceData.discount_amount ?? null;
        
        this.taxMeta = {
          per: invoiceData.tax_per ?? "",
          amount: invoiceData.tax_amount ?? "",
          type: invoiceData.tax_type ?? "",
          value_type: invoiceData.tax_value_type ?? "",
        };
        this.tax_input.value.value = this.formatChargeValue(
          invoiceData.tax_per,
          invoiceData.tax_amount,
          invoiceData.tax_type
        );
        this.taxAmountPrefill = invoiceData.tax_amount ?? null;
        
        this.vatMeta = {
          per: invoiceData.vat_per ?? "",
          amount: invoiceData.vat_amount ?? "",
          type: invoiceData.vat_type ?? "",
          value_type: invoiceData.vat_value_type ?? "",
        };
        this.vat_input.value.value = this.formatChargeValue(
          invoiceData.vat_per,
          invoiceData.vat_amount,
          invoiceData.vat_type
        );
        this.vatAmountPrefill = invoiceData.vat_amount ?? null;
        
        // Populate cart from invoice details FIRST (before loading PO Receive)
        this.cart = [];
        const details = invoiceData.purInvoiceDetails || invoiceData.pur_invoice_details || [];
        console.log("Invoice details for cart:", details);
        console.log("Invoice data structure:", invoiceData);
        
        if (details && details.length > 0) {
          details.forEach((item) => {
            this.cart.push({
              product_id: item.product_id,
              product_name: item.product?.name || "",
              product_code: item.product?.code || "",
              qty: Number(item.qty || 0),
              free_qty: Number(item.free_qty || 0),
              unit_name: item.product?.unit?.name || "",
              rate: Number(item.rate || 0),
              total: Number(item.qty || 0) * Number(item.rate || 0),
            });
          });
          console.log("Cart populated with", this.cart.length, "items from invoice details");
        } else {
          console.warn("No invoice details found in response. Available keys:", Object.keys(invoiceData));
        }
        
        // Determine receive type and load appropriate data
        const poReceiveId = invoiceData.inv_po_receive_master_id || invoiceData.po_receive_master_id || invoiceData.poReceiveMaster?.id;
        const assetAcquisitionId = invoiceData.asset_acquisition_master_id || invoiceData.assetAcquisitionMaster?.id;
        
        if (poReceiveId) {
          this.receive_type.value.value = 'PO_RECEIVE';
          this.po_receive_master_id.value.value = poReceiveId;
          this.asset_acquisition_master_id.value.value = null;
          
          // Load full PO Receive data to populate all fields
          try {
            const poReceiveData = await this.$store.dispatch("getInvPoReceiveById", poReceiveId);
            // Save cart before calling populateFromReceive (which will overwrite it)
            const savedCart = [...this.cart];
            this.populateFromReceive(poReceiveData);
            // Restore cart from invoice details (not from PO Receive)
            this.cart = savedCart;
            // Override with invoice-specific data (preserve invoice values)
            this.purchase_invoice_master_id.value.value = invoiceData.id;
            this.invoice_date.value.value = invoiceData.invoice_date
              ? new Date(invoiceData.invoice_date)
              : new Date();
            // Restore invoice-specific discount, tax, vat values
            this.discountMeta = {
              per: invoiceData.discount_per ?? "",
              amount: invoiceData.discount_amount ?? "",
              type: invoiceData.discount_type ?? "",
            };
            this.discount_input.value.value = this.formatChargeValue(
              invoiceData.discount_per,
              invoiceData.discount_amount,
              invoiceData.discount_type
            );
            this.discountAmountPrefill = invoiceData.discount_amount ?? null;
            
            this.taxMeta = {
              per: invoiceData.tax_per ?? "",
              amount: invoiceData.tax_amount ?? "",
              type: invoiceData.tax_type ?? "",
              value_type: invoiceData.tax_value_type ?? "",
            };
            this.tax_input.value.value = this.formatChargeValue(
              invoiceData.tax_per,
              invoiceData.tax_amount,
              invoiceData.tax_type
            );
            this.taxAmountPrefill = invoiceData.tax_amount ?? null;
            
            this.vatMeta = {
              per: invoiceData.vat_per ?? "",
              amount: invoiceData.vat_amount ?? "",
              type: invoiceData.vat_type ?? "",
              value_type: invoiceData.vat_value_type ?? "",
            };
            this.vat_input.value.value = this.formatChargeValue(
              invoiceData.vat_per,
              invoiceData.vat_amount,
              invoiceData.vat_type
            );
            this.vatAmountPrefill = invoiceData.vat_amount ?? null;
          } catch (error) {
            console.error("Failed to load PO Receive data:", error);
            // If PO Receive loading fails, still populate from invoice
            this.supplierName = invoiceData.supplier?.supplier_name || "";
            this.supplier_id.value.value = invoiceData.supplier_id || invoiceData.supplier?.id || null;
            // Try to get warehouse from invoice if available
            if (invoiceData.warehouse_id || invoiceData.warehouse?.id) {
              this.warehouse_id.value.value = invoiceData.warehouse_id || invoiceData.warehouse?.id || null;
              this.warehouseName = invoiceData.warehouse?.name || "";
            }
            this.purpose_id.value.value = invoiceData.purpose_id;
          }
        } else if (assetAcquisitionId) {
          this.receive_type.value.value = 'ASSET_ACQUISITION';
          this.asset_acquisition_master_id.value.value = assetAcquisitionId;
          this.po_receive_master_id.value.value = null;
          
          // Load full Asset Acquisition data to populate all fields
          try {
            const assetAcquisitionData = await this.$store.dispatch("getAssetAcquisitionById", assetAcquisitionId);
            // Save cart before calling populateFromAssetAcquisition (which will overwrite it)
            const savedCart = [...this.cart];
            this.populateFromAssetAcquisition(assetAcquisitionData);
            // Restore cart from invoice details (not from Asset Acquisition)
            this.cart = savedCart;
            // Override with invoice-specific data (preserve invoice values)
            this.purchase_invoice_master_id.value.value = invoiceData.id;
            this.invoice_date.value.value = invoiceData.invoice_date
              ? new Date(invoiceData.invoice_date)
              : new Date();
            // Restore invoice-specific discount, tax, vat values
            this.discountMeta = {
              per: invoiceData.discount_per ?? "",
              amount: invoiceData.discount_amount ?? "",
              type: invoiceData.discount_type ?? "",
            };
            this.discount_input.value.value = this.formatChargeValue(
              invoiceData.discount_per,
              invoiceData.discount_amount,
              invoiceData.discount_type
            );
            this.discountAmountPrefill = invoiceData.discount_amount ?? null;
            
            this.taxMeta = {
              per: invoiceData.tax_per ?? "",
              amount: invoiceData.tax_amount ?? "",
              type: invoiceData.tax_type ?? "",
              value_type: invoiceData.tax_value_type ?? "",
            };
            this.tax_input.value.value = this.formatChargeValue(
              invoiceData.tax_per,
              invoiceData.tax_amount,
              invoiceData.tax_type
            );
            this.taxAmountPrefill = invoiceData.tax_amount ?? null;
            
            this.vatMeta = {
              per: invoiceData.vat_per ?? "",
              amount: invoiceData.vat_amount ?? "",
              type: invoiceData.vat_type ?? "",
              value_type: invoiceData.vat_value_type ?? "",
            };
            this.vat_input.value.value = this.formatChargeValue(
              invoiceData.vat_per,
              invoiceData.vat_amount,
              invoiceData.vat_type
            );
            this.vatAmountPrefill = invoiceData.vat_amount ?? null;
          } catch (error) {
            console.error("Failed to load Asset Acquisition data:", error);
            // If Asset Acquisition loading fails, still populate from invoice
            this.supplierName = invoiceData.supplier?.supplier_name || "";
            this.supplier_id.value.value = invoiceData.supplier_id || invoiceData.supplier?.id || null;
          }
        }
        
      } catch (error) {
        console.error("Error populating invoice data:", error);
        toast.error("Failed to load invoice data");
      }
    },
    async loadInvoiceForEdit(invoiceId) {
      try {
        this.loading = true;
        this.$store.commit("SET_LOADING", { color: "primary" });
        const invoiceData = await this.$store.dispatch("getPurInvoiceById", invoiceId);
        await this.populateFromInvoice(invoiceData);
      } catch (error) {
        console.error("Failed to load invoice:", error);
        toast.error(
          error?.response?.data?.message || "Failed to load invoice"
        );
      } finally {
        this.loading = false;
        this.$store.commit("UNSET_LOADING");
      }
    },
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const router = useRouter();

    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        receive_type: yup.string().required().label("Receive Type"),
        po_receive_master_id: yup.number().when("receive_type", {
          is: "PO_RECEIVE",
          then: (schema) => schema.required("PO Receive is required").positive().integer(),
          otherwise: (schema) => schema.nullable(),
        }),
        asset_acquisition_master_id: yup.number().when("receive_type", {
          is: "ASSET_ACQUISITION",
          then: (schema) => schema.required("Asset Acquisition Receive is required").positive().integer(),
          otherwise: (schema) => schema.nullable(),
        }),
        invoice_date: yup.date().required().label("Invoice Date"),
      }),
    });

    const purchase_invoice_master_id = useField("purchase_invoice_master_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const requisition_master_id = useField("requisition_master_id");
    const receive_type = useField("receive_type");
    const po_receive_master_id = useField("po_receive_master_id");
    const asset_acquisition_master_id = useField("asset_acquisition_master_id");
    const invoice_date = useField("invoice_date");
    const purchase_date = useField("purchase_date");
    const receive_date = useField("receive_date");
    const shipping_date = useField("shipping_date");
    const purchase_type = useField("purchase_type");
    const warehouse_id = useField("warehouse_id");
    const purpose_id = useField("purpose_id");
    const supplier_invoice_no = useField("supplier_invoice_no");
    const supplier_id = useField("supplier_id");
    const remarks = useField("remarks");
    const discount_input = useField("discount_input");
    const tax_input = useField("tax_input");
    const vat_input = useField("vat_input");
    const status = useField("status");

    invoice_date.value.value = new Date();
    status.value.value = 1;

    const submitForm = (statusValue) => {
      status.value.value = statusValue;
      submit();
    };

    const getDiscountType = (input, discountMeta = null) => {
      // Automatically determine discount_type based on input
      // 1 = percent, 2 = flat, null = no discount
      
      // Helper to check if a value is meaningful (not null, undefined, empty string, or 0)
      const hasValue = (val) => {
        if (val === null || val === undefined) return false;
        if (typeof val === 'string' && val.trim() === '') return false;
        if (typeof val === 'number' && val === 0) return false;
        return true;
      };
      
      // First, try to determine from input value
      if (input !== undefined && input !== null && input !== "") {
        const val = input.toString().trim();
        if (val) {
          return val.endsWith("%") ? 1 : 2;
        }
      }
      
      // If input is empty, try to determine from discountMeta
      if (discountMeta) {
        // Check if type is explicitly set
        if (hasValue(discountMeta.type)) {
          return Number(discountMeta.type) === 1 ? 1 : 2;
        }
        
        // If discountMeta has both per and amount but no type, prefer amount (flat)
        // This handles legacy data where discount_type was null
        const hasPer = hasValue(discountMeta.per);
        const hasAmount = hasValue(discountMeta.amount);
        
        if (hasAmount && hasPer) {
          // Both exist - prefer flat (amount) for legacy data
          return 2;
        }
        if (hasPer && !hasAmount) {
          // Only percentage exists
          return 1;
        }
        if (hasAmount && !hasPer) {
          // Only amount exists
          return 2;
        }
      }
      
      return null;
    };

    // Generic helper to determine value type (1 = percent, 2 = flat, null = none)
    const getValueType = (input, meta = null) => {
      // Reuse the same rules as discount_type: percent if it ends with '%', otherwise flat

      const hasValue = (val) => {
        if (val === null || val === undefined) return false;
        if (typeof val === "string" && val.trim() === "") return false;
        if (typeof val === "number" && val === 0) return false;
        return true;
      };

      if (input !== undefined && input !== null && input !== "") {
        const val = input.toString().trim();
        if (val) {
          return val.endsWith("%") ? 1 : 2;
        }
      }

      if (meta) {
        if (hasValue(meta.per) && !hasValue(meta.amount)) {
          return 1;
        }
        if (hasValue(meta.amount)) {
          return 2;
        }
      }

      return null;
    };

    const submit = handleSubmit((values) => {
      if (!proxy.cart.length) {
        toast.error("Cart is empty");
        return;
      }

      values.purchase_invoice_master_id =
        purchase_invoice_master_id.value.value;
      values.pur_invoice_master_id = purchase_invoice_master_id.value.value;
      values.pur_order_master_id = pur_order_master_id.value.value;
      values.receive_type = receive_type.value.value;
      
      // Set receive master id based on receive type
      // Only send the relevant field, don't send the other as null
      if (receive_type.value.value === 'PO_RECEIVE') {
        values.po_receive_master_id = po_receive_master_id.value.value;
        values.inv_po_receive_master_id = po_receive_master_id.value.value;
        // Don't send asset_acquisition fields at all for PO_RECEIVE
        delete values.asset_acquisition_master_id;
        delete values.asset_register_acquisition_master_id;
      } else if (receive_type.value.value === 'ASSET_ACQUISITION') {
        values.asset_register_acquisition_master_id = asset_acquisition_master_id.value.value;
        values.asset_acquisition_master_id = asset_acquisition_master_id.value.value;
        // Don't send po_receive fields at all for ASSET_ACQUISITION
        delete values.po_receive_master_id;
        delete values.inv_po_receive_master_id;
      }
      values.invoice_date = formattedDate(invoice_date.value.value);
      values.purchase_date = formattedDate(purchase_date.value.value);
      values.receive_date = formattedDate(receive_date.value.value);
      values.shipping_date = formattedDate(shipping_date.value.value);
      values.purchase_type = purchase_type.value.value;
      values.requisition_master_id = requisition_master_id.value.value;
      values.warehouse_id = warehouse_id.value.value;
      values.purpose_id = purpose_id.value.value;
      values.supplier_invoice_no = supplier_invoice_no.value.value;
      values.supplier_id = supplier_id.value.value;
      values.remarks = remarks.value.value;
      values.discount_input = discount_input.value.value;
      values.tax_input = tax_input.value.value;
      values.vat_input = vat_input.value.value;
      values.discount_per = proxy.normalizePercentageValue(
        proxy.discountMeta.per
      );
      // Get discount_type - check input first, then fallback to discountMeta
      // Also check discountMeta.per and discountMeta.amount directly as fallback
      let discountInputValue = discount_input.value.value;
      
      // If input is empty but we have discountMeta values, try to reconstruct the input
      if ((!discountInputValue || discountInputValue === "") && proxy.discountMeta) {
        // Reconstruct from discountMeta to determine type
        if (proxy.discountMeta.per && proxy.discountMeta.amount) {
          // Both exist - use amount (flat) for legacy data
          discountInputValue = String(proxy.discountMeta.amount);
        } else if (proxy.discountMeta.per) {
          // Only percentage exists
          discountInputValue = String(proxy.discountMeta.per) + "%";
        } else if (proxy.discountMeta.amount) {
          // Only amount exists
          discountInputValue = String(proxy.discountMeta.amount);
        }
      }
      
      values.discount_type = getDiscountType(discountInputValue, proxy.discountMeta);
      
      // Debug log to help troubleshoot
      console.log("Discount type calculation:", {
        originalInput: discount_input.value.value,
        reconstructedInput: discountInputValue,
        discountMeta: proxy.discountMeta,
        calculatedType: values.discount_type
      });
      values.tax_per = proxy.normalizePercentageValue(proxy.taxMeta.per);
      values.vat_per = proxy.normalizePercentageValue(proxy.vatMeta.per);
      values.tax_type = proxy.normalizeTypeValue(proxy.taxMeta.type);
      values.vat_type = proxy.normalizeTypeValue(proxy.vatMeta.type);
      // Determine value types (percent vs flat) for tax and vat
      values.tax_value_type = getValueType(tax_input.value.value, proxy.taxMeta);
      values.vat_value_type = getValueType(vat_input.value.value, proxy.vatMeta);
      values.status = status.value.value;
      values.sub_total = proxy.subTotal;
      values.discount_amount = proxy.discountAmount;
      values.tax_amount = proxy.taxAmount;
      values.vat_amount = proxy.vatAmount;
      values.grand_total = proxy.grandTotal;
      values.cart = proxy.cart.map((item) => ({
        product_id: item.product_id,
        qty: Number(item.qty || 0),
        free_qty: Number(item.free_qty || 0),
        rate: Number(item.rate || 0),
        total: Number(item.total || 0),
      }));

      // Debug: Log the data being sent
      console.log("Saving invoice data:", {
        isEditMode: proxy.isEditMode,
        pur_invoice_master_id: values.pur_invoice_master_id,
        receive_type: values.receive_type,
        inv_po_receive_master_id: values.inv_po_receive_master_id,
        asset_acquisition_master_id: values.asset_acquisition_master_id,
        asset_register_acquisition_master_id: values.asset_register_acquisition_master_id,
        cartItems: values.cart.length,
        status: values.status
      });

      store
        .dispatch("saveUpdatePurInvoice", values)
        .then((response) => {
          toast.success(
            response?.data?.message || "Invoice saved successfully",
            {
              timeout: 3000,
            }
          );
          // If editing, redirect back to list
          if (proxy.isEditMode) {
            proxy.isEditMode = false;
            proxy.$router.push({ name: "purchase-invoice-record" }).catch(() => {});
          } else {
            resetForm();
            proxy.resetInvoiceForm(true);
            proxy.invoice_date.value.value = new Date();
          }
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.message || "Failed to save invoice"
          );
        });
    });

    return {
      submitForm,
      submit,
      purchase_invoice_master_id,
      pur_order_master_id,
      requisition_master_id,
      receive_type,
      po_receive_master_id,
      asset_acquisition_master_id,
      invoice_date,
      purchase_date,
      receive_date,
      shipping_date,
      purchase_type,
      warehouse_id,
      purpose_id,
      supplier_invoice_no,
      supplier_id,
      remarks,
      discount_input,
      tax_input,
      vat_input,
      status,
    };
  },
  mounted() {
    this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;
    // Check if we're editing an existing invoice
    const invoiceId = this.$route.query.id;
    if (invoiceId) {
      this.loadInvoiceForEdit(invoiceId);
    }
  },
};
</script>

